module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.16d14ad3.woff";